const __DEV__ = false;

function composeEventHandlers(theirHandler, ourHandler) {
  return function (event) {
    theirHandler && theirHandler(event);
    if (!event.defaultPrevented) {
      return ourHandler(event);
    }
  };
}

export { composeEventHandlers };
//# sourceMappingURL=compose-event-handlers.js.map
